<template>
    <button @click="request" :disabled="requesting" class="pure-button">Request</button>
</template>

<script>
export default {
  name: 'ScreenshotRequestButton',
  props: {
    user: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      requesting: false
    }
  },
  methods: {
    async request () {
      this.requesting = true
      let response = await this.user !== null ? this.$store.dispatch('screenshots/request', this.user)
        : this.$store.dispatch('screenshots/requestAll')
      console.log(response)
      this.requesting = false
      const message = this.user !== null ? `Screenshot requested from ${this.user}`
        : 'Screenshot requested from all users'
      this.$toast(message, {
        timeout: 2000
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/screenshots/ScreenshotRequestButton.vue